export interface FaqItem {
  q: string;
  a: string;
}

/**
 * Questions as a ruled list, the way a printed Q&A sets them: question in the headline
 * face, a hairline between each, the answer at reading width. No surrounding card.
 */
export function Faq({ items }: { items: FaqItem[] }) {
  return (
    <div className="border-t border-border">
      {items.map((it, i) => (
        <details key={i} className="group border-b border-border">
          <summary className="flex cursor-pointer list-none items-start justify-between gap-6 py-4 font-display text-lg font-medium leading-snug text-foreground transition-colors hover:text-primary sm:text-xl">
            {it.q}
            <span aria-hidden className="no-print relative mt-2 h-3 w-3 shrink-0 text-primary">
              <span className="absolute inset-x-0 top-1/2 h-[1.5px] -translate-y-1/2 bg-current" />
              <span className="absolute inset-y-0 left-1/2 w-[1.5px] -translate-x-1/2 bg-current transition-transform duration-200 group-open:scale-y-0" />
            </span>
          </summary>
          <p className="measure pb-5 pr-8 text-[0.9375rem] leading-relaxed text-muted-foreground">
            {it.a}
          </p>
        </details>
      ))}
    </div>
  );
}

export function faqJsonLd(items: FaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };
}
